import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  gridItems: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
}));

export default useStyles;
